import { action, computed, makeObservable, observable } from 'mobx';
import { inject, observer } from 'mobx-react';
import NumeroProcessoUtil, { ConfiguracaoPesquisaNumeroProcesso } from '../../util/NumeroProcessoUtil';
import NumeroProcesso from '../NumeroProcesso';
import ReactComponent from '../ReactComponent';
import ModalBuscaProcesso from './ModalBuscaProcesso';

class BuscarProcessoPorNumero extends ReactComponent {
    openModalBuscaProcesso = false;
    processosFiltrados = [];

    constructor(props) {
        super(props);

        makeObservable(this, {
            openModalBuscaProcesso: observable,
            processosFiltrados: observable,
            processos: computed,
            onCloseModalBuscarProcesso: action,
            buscarPorNumeroProcesso: action
        });
    }

    get processos() {
        return this.observableProps.processos;
    }

    onCloseModalBuscarProcesso = () => {
        this.openModalBuscaProcesso = false;
    };

    buscarPorNumeroProcesso = (numeroCompleto) => {
        const configuracaoPesquisa = new ConfiguracaoPesquisaNumeroProcesso(true, true, true);
        let processosFiltrados = this.processos.filter((registro) =>
            NumeroProcessoUtil.compararNumeroProcesso(
                registro.processo.numeroCompleto,
                numeroCompleto,
                configuracaoPesquisa
            )
        );

        if (
            processosFiltrados.length === 1 &&
            processosFiltrados[0].numeroProcesso.split('-')[0] === numeroCompleto.numero
        ) {
            this.observableProps.callbackAbrirProcesso(processosFiltrados[0]);
        } else if (processosFiltrados.length > 0) {
            this.processosFiltrados = processosFiltrados
                .slice()
                .sort(
                    (p1, p2) =>
                        parseInt(p1.numeroProcesso.split('-')[0], 10) - parseInt(p2.numeroProcesso.split('-')[0], 10)
                );

            this.openModalBuscaProcesso = true;
        } else {
            this.mensagemStore.abrirMensagemInfo(
                'Nenhum processo que corresponda aos parâmetros informados foi encontrado nas listagens de processos (' +
                    this.store.getDescricoesOpcoesProcessos().toUpperCase() +
                    ')'
            );
        }
    };

    render() {
        return (
            <>
                {this.openModalBuscaProcesso && (
                    <ModalBuscaProcesso
                        open={this.openModalBuscaProcesso}
                        onClose={this.onCloseModalBuscarProcesso}
                        callbackAbrirProcesso={this.observableProps.callbackAbrirProcesso}
                        processos={this.processosFiltrados}
                        id="no-print"
                    />
                )}
                <NumeroProcesso
                    dense
                    color="white"
                    callback={this.buscarPorNumeroProcesso}
                    clickSearch={this.buscarPorNumeroProcesso}
                />
            </>
        );
    }
}

export default inject('stores')(observer(BuscarProcessoPorNumero));
